'use client'
import { createContext, useContext, useMemo } from 'react'
import { localePath, isRtl, FALLBACK_LOCALES } from '@utils/locales'

// null = no provider above (e.g. a component rendered outside the layout tree)
const LocaleContext = createContext(null)

export function LocaleProvider({ locale, locales, defaultLocale, children }) {
  const value = useMemo(
    () => ({ locale, locales, defaultLocale }),
    [locale, locales, defaultLocale]
  )
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
}

// const { locale, locales, defaultLocale, href, dir } = useLocales()
// href('th', '/services') → '/th/services'
export function useLocales() {
  const ctx = useContext(LocaleContext) ?? {
    locale: FALLBACK_LOCALES.defaultLocale,
    ...FALLBACK_LOCALES,
  }
  return {
    ...ctx,
    dir: isRtl(ctx.locale) ? 'rtl' : 'ltr',
    href: (locale, path) => localePath(locale, path, ctx.defaultLocale),
  }
}